module.exports = __webpack_public_path__ + "img/7.9712f1a2.png";